"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onEntryChange = exports.Stack = void 0;

var _livePreviewUtils = _interopRequireDefault(require("@contentstack/live-preview-utils"));

var _contentstack = _interopRequireDefault(require("contentstack"));

const {
  CONTENTSTACK_API_HOST = 'eu-api.contentstack.com'
} = process.env;
const {
  CONTENTSTACK_APP_HOST = 'eu-app.contentstack.com'
} = process.env;
const config = {
  api_key: process.env.CONTENTSTACK_API_KEY,
  delivery_token: process.env.CONTENTSTACK_DELIVERY_TOKEN,
  environment: process.env.CONTENTSTACK_ENVIRONMENT,
  live_preview: {
    management_token: process.env.CONTENTSTACK_MANAGEMENT_TOKEN,
    enable: true,
    host: CONTENTSTACK_API_HOST
  }
};

const Stack = _contentstack.default.Stack(config);

exports.Stack = Stack;

if (CONTENTSTACK_API_HOST) {
  Stack.setHost(CONTENTSTACK_API_HOST);
}

_livePreviewUtils.default.init({
  enable: process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW === 'true',
  // @ts-expect-error: TS2739
  stackSdk: Stack,
  clientUrlParams: {
    host: CONTENTSTACK_APP_HOST
  },
  ssr: false
});

const {
  onEntryChange
} = _livePreviewUtils.default;
exports.onEntryChange = onEntryChange;